import { useRef } from "react";
import { Img1, Img2, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com4 = () => {
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper>
      <Img1
        loading="lazy"
        src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/7c6ffbb5BrandDesign_10.svg"
        alt="BrandDesign_10.svg"
        ref={ref1}
        className="fade-in"
      />
    </Wrapper>
  );
};

export default Com4;
